import _styled from "styled-components";
import React from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';
import { transformToSEOLinks } from "./transformToSEOLinks";
export var SEOLinks = function SEOLinks(_ref) {
  var content = _ref.content;
  var links = transformToSEOLinks(content);
  return /*#__PURE__*/React.createElement(_StyledDiv, null, links.map(function (link, index) {
    return /*#__PURE__*/React.createElement("a", {
      href: link.url,
      key: index
    }, link.title);
  }));
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "SEOLinks___StyledDiv",
  componentId: "sc-xor7xt-0"
})(["", ""], visuallyHidden);